import { Component } from 'react';
import { withRouter} from "react-router-dom";
import {ResponseDownloadFormContext} from './EdiaryResponseDownloadContext'
import EdiaryResponseService from "../../services/ediaryResponse.service";
import GetErrorMessage  from '../../helpers/error-message'
import {ShowError, ShowSuccess} from "../../components/toast"
import ValidateResponseDownload from './EdiaryResponseDownloadValidation'
import SelectionFilters from './SelectionFiltersModel'
import { Button} from 'app/components/Basics/';
import Filters from './components/Filters/FiltersComponent';
import { GlobalStateContext } from 'app/contexts/GlobalStateContext';

class ResponseDownloadForm extends Component {    
    static contextType = GlobalStateContext; 
    constructor(props){
        super(props);
        this.state = {
            showFiltersModal: false,            
            selectedSelectionFilters: SelectionFilters(),
            errors: []
        }        
    }

    openFiltersModal() {
		this.setState({ showFiltersModal: true });
	}	

	closeFiltersModal() {		
		this.setState({ showFiltersModal: false });
	}    

        updateSelectedSelectionFilters(selectedSelectionFilters) {
		this.setState({selectedSelectionFilters: selectedSelectionFilters})
    }

    downloadResponses(responseDownloadSet) {                
        responseDownloadSet.questions = (this.props.metadata.questions || []).map(question => question.value);
        this.props.toggleUiBlock(true);
        EdiaryResponseService.generate(responseDownloadSet)
            .then(response => {					
                const { addFileDownloadJobId } = this.context;
                addFileDownloadJobId(response.jobId);
                this.props.toggleUiBlock(false);                
            })
            .catch(error => {
                let errorMessage = GetErrorMessage(error);
                console.log("errorMessage on catch");
                console.log(errorMessage);
                this.props.toggleUiBlock(false);
                this.setState({ errorMessage: errorMessage});
            });
    }

    handleSubmitAction = event => {        
        var validationErrors = ValidateResponseDownload(this.state.selectedSelectionFilters);
        this.setState({errors: validationErrors});
        if (validationErrors && validationErrors.length === 0) {                    
            this.downloadResponses(this.state.selectedSelectionFilters);
        }
        return;
    }

    isDisabled() {
		if (!this.state.selectedSelectionFilters) {
			return true;
		}
		var errors = ValidateResponseDownload(this.state.selectedSelectionFilters);
		if (errors?.length > 0) {
			return true;
		} 
		else {
			return false;
		}
	}
    
    render() {    
        return (
            <div className="AppFormComponent ResponseDownloadForm">                 
                <ResponseDownloadFormContext.Provider value={{
					updateSelectedSelectionFilters: this.updateSelectedSelectionFilters.bind(this), 
					selectedSelectionFilters: this.state.selectedSelectionFilters}}>                
                    <form ref={ form => this.formEl = form } onSubmit={ this.handleSubmitAction }>
                        <div className="form-head">      
                            <div className="form-row downloadResponsesHeader">
					            Download Responses
				            </div>                      
                            <div className="last-data-import">
                                <h4>Last Data Import: {this.props.metadata?.lastImportDate}</h4>
                            </div>
                            <div>                            
                                <Filters metadata={this.props.metadata}></Filters>				
                                <div className="form-row" style={{paddingTop:20}}>
                                    <div className="form-row-left">
                                        <Button disabled={this.isDisabled()} title="Download responses data as a CSV file" onClick={this.handleSubmitAction.bind(this)}>Download Data</Button>
                                    </div>					
                                </div>
                            </div>
                        </div>
                    </form>                    
                </ResponseDownloadFormContext.Provider>
                {this.state.errorMessage && ( <ShowError clearErrorMessage={() => this.setState({errorMessage: ''})} errorMessage={this.state.errorMessage} /> )}
                {this.state.successMessage && ( <ShowSuccess clearMessage={() => this.setState({successMessage: ''})} message={this.state.successMessage} /> )}                
            </div>            
        );
    }
}
export default withRouter(ResponseDownloadForm);